import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import HistoryIcon from '@material-ui/icons/History';
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import CloseIcon from '@material-ui/icons/Close';
import axios from 'src/utils/axiosCatalog';
import {
  Box,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Backdrop,
  CircularProgress
} from '@material-ui/core';
import Moment from 'moment';
import Page from 'src/components/Page';
import DisplayField from 'src/components/DisplayField';
import History from './History';
import UrunTarihce from './ProductHistory';
import Bulten from './Bulletin';
import Notes from './Notes';
// import Degisim from "./ProductChange"
import { getConsumerWorkOrder, getPaymentDetails } from '../../../store/slices/workOrderDetailSlice';
import Fotograf from './Photo';
import 'src/api/mock';
import { getUser, moneyFormat } from 'src/utils/Common';

const WorkOrderDetail = WorkOrderId => {
  const { t } = useTranslation(['overview']);
  const dispatch = useDispatch();
  const [consumerInformation, setConsumerInformation] = useState([]);
  const workOrderInformation = useSelector(
    state => state.workOrderDetail.WorkOrderInformation
  );
  const PaymentDetails = useSelector(
    state => state.workOrderDetail.PaymentDetails
  ) || [];
  const [consumerPrimaryAddress, setConsumerPrimaryAddress] = useState({});
  const [workOrderLabourList, setWorkOrderLabourList] = useState([]);
  const [workOrderMaterialList, setWorkOrderMaterialList] = useState([]);
  const [workOrderTransportList, setWorkOrderTransportList] = useState([]);
  const [workOrderExtraList, setWorkOrderExtraList] = useState([]);
  const [workOrderDetailList, setWorkOrderDetailList] = useState([]);
  const [workOrderVerificationList, setWorkOrderVerificationList] = useState(
    []
  );
  const [productNotesPopup, setProductNotesPopup] = useState(false);
  const [LibraryDialog, setLibraryDialog] = useState(false);
  const [ProductHistoryDialog, setProductHistoryDialog] = useState(false);
  const [WorkOrderHistoryDialog, setWorkOrderHistoryDialog] = useState(false);
  const [FileDialog, setFileDialog] = useState(false);
  const [data] = useState({});
  const [SecretNoteData, setSecretNoteData] = useState([]);
  const [CommentDialog, setCommentDialog] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [WorkOrderCommentsData, setWorkOrderCommentsData] = useState([]);
  const SessionUser = getUser();
  const [materialSum, setMaterialSum] = useState(0);
  const [labourSum, setLabourSum] = useState(0);
  const [transportSum, setTransportSum] = useState(0);
  const [extraPriceSum, setExtraPriceSum] = useState(0);
  const [ASIFormInfoList, setASIFormInfoList] = useState([]);

  Moment.locale(SessionUser.TenantCode === 'my' ? 'en' : SessionUser.TenantCode);

  const useStyles = makeStyles(theme => ({
    root: {},
    content: {
      minHeight: 430
    },
    submitButtonFile: {
      width: '100%'
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff'
    },
    cardsMax: {
      maxHeight: 550,
      minHeight: 550
    }
  }));

  const classes = useStyles();
  const { ReceiptNo } = consumerInformation;

  useEffect(() => {
    if (
      WorkOrderId.WorkOrderId === undefined ||
      WorkOrderId.WorkOrderId === 0 ||
      WorkOrderId.WorkOrderId === '0'
    ) {
      setConsumerInformation([]);
    } else {
      setLoading(true);
      dispatch(getConsumerWorkOrder(WorkOrderId.WorkOrderId))
        .then(response => {
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
        });
    }
  }, [dispatch, WorkOrderId.WorkOrderId]);

  useEffect(() => {
    if (
      Number(SessionUser?.TenantId) === 75 &&
      WorkOrderId.WorkOrderId
    ) {
      dispatch(getPaymentDetails(WorkOrderId.WorkOrderId));
    }
  }, [dispatch, WorkOrderId.WorkOrderId, SessionUser?.TenantId]);

  useEffect(() => {
    if (
      WorkOrderId.WorkOrderId === undefined ||
      WorkOrderId.WorkOrderId === 0 ||
      WorkOrderId.WorkOrderId === '0'
    ) {
      setConsumerInformation([]);
      setSecretNoteData([]);
    } else if (workOrderInformation?.length > 0) {
      const value = workOrderInformation.slice();
      const primaryAdress = value[0].Addresses.find(
        x => x.AddressId === value[0].ConsumerAddressId
      );
      setWorkOrderLabourList(value[0].WorkOrderLabours);
      setWorkOrderMaterialList(value[0].WorkOrderMaterials);
      setWorkOrderTransportList(value[0].WorkOrderTransport);
      setWorkOrderExtraList(value[0].WorkOrderExtra);
      setWorkOrderVerificationList(value[0].WorkOrderVerification);
      setWorkOrderDetailList(value[0].WorkOrderDetails);
      setConsumerInformation(value[0]);
      GetSecretNote(value[0].ConsumerId);
      setConsumerPrimaryAddress(primaryAdress);
      setASIFormInfoList(value[0].ASIFormInfo);
    } else {
      setConsumerInformation([]);
      setConsumerPrimaryAddress('');
    }
  }, [workOrderInformation, WorkOrderId.WorkOrderId]);

  useEffect(() => {

    var sum = 0;

    if (workOrderLabourList?.length > 0) {
      workOrderLabourList.map(row => (sum = sum + row.LabourPriceWithWat));
    }

    setLabourSum(sum);
    sum = 0;

    if (workOrderMaterialList?.length > 0) {
      workOrderMaterialList.map(row => (sum = sum + row.MaterialPriceWithWat * row.Count));
    }

    setMaterialSum(sum);
    sum = 0;

    if (workOrderTransportList?.length > 0) {
      workOrderTransportList.map(row => (sum = sum + row.MaterialPriceWithWat));
    }
    /*if (workOrderExtraList?.length > 0) {
      workOrderExtraList.map(row => (sum = sum + row.MaterialPriceWithWat));
    }*/

    setTransportSum(sum);
    sum = 0;
    if (workOrderExtraList?.length > 0) {
      workOrderExtraList.map(row => (sum = sum + row.MaterialPriceWithWat));
    }

    setExtraPriceSum(sum);
  }, [
    workOrderTransportList,
    workOrderMaterialList,
    workOrderLabourList,
    workOrderExtraList
  ]);

  const getWorkOrderCommentDetail = () => {
    setLoading(true);
    axios
      .get(`/GetWorkOrderCommentDetail/${ReceiptNo}`)
      .then(response => {
        if (response.data.length > 0) {
          setWorkOrderCommentsData(response.data);
          setCommentDialog(true);
          setLoading(false);
        }
      })
      .catch(error => { });
    setLoading(false);
  };

  const GetSecretNote = ConsumerId => {
    setLoading(true);
    axios
      .get(`/GetConsumerSecretNote/${ConsumerId}`)
      .then(response => {
        const ResponseData = response.data;
        if (ResponseData.length === 0) {
          setSecretNoteData([]);
        } else {
          setSecretNoteData(ResponseData);
        }
        setLoading(false);
      })
      .catch(error => {
        setSecretNoteData([]);
        setLoading(false);
      });
  };

  return (
    <div>
      <Backdrop className={classes.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container maxWidth="xl">
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} lg={12}>
                <Card
                // style={{ maxHeight: 400, minHeight: 400 }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <CardHeader
                        style={{ textAlign: 'left' }}
                        title={t('lblVerificationList')}
                        action={<Box p={2.5} />}
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">
                              {t('lblVerificationId')}
                            </TableCell>
                            {/* <TableCell align="center">{t('lblVerificationDesc')}</TableCell> */}
                            <TableCell align="center">
                              {t('lblVerificationName')}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {workOrderVerificationList?.length > 0
                            ? workOrderVerificationList.map(row => (
                              <TableRow key={row.LabourId}>
                                <TableCell align="center">{row.Id}</TableCell>
                                {/* <TableCell align="center">{row.Dsc}</TableCell> */}
                                <TableCell align="center">
                                  {row.FieldText}
                                </TableCell>
                              </TableRow>
                            ))
                            : null}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} lg={6}>
                <Card style={{ maxHeight: 430, minHeight: 430 }}>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <CardHeader
                        style={{ textAlign: 'left' }}
                        title={t('lblCustomerInfo')}
                        action={<Box p={2.5} />}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <CardHeader
                        style={{ textAlign: 'right' }}
                        title={consumerInformation.ConsumerId}
                        action={<Box p={2.5} />}
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={6} lg={6}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblCustomerName')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.CustomerFullName}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblCustomerEmail')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.CustomerEmail}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblContactPhone')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ContactPhone}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblAddress')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerPrimaryAddress?.Address}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblConsumerNotes')}
                        </Typography>
                        {SecretNoteData
                          ? SecretNoteData.map(row => (
                            <Typography
                              variant="h6"
                              component="h2"
                              gutterBottom
                            >
                              {row.UserSecretNote + ' - ' + row.SecretNote}
                            </Typography>
                          ))
                          : null}
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblNonTax')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ExceptId}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblConsumerType')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ConsumerTypeName}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblIdentityNumber')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.IdNr}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblTaxId')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.TaxId}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblTaxOffice')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.TaxOffice}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} lg={6}>
                <Card style={{ maxHeight: 400, minHeight: 400 }}>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <CardHeader
                        style={{ textAlign: 'left' }}
                        title={t('lblProductChangeInfo')}
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblChangeTaxOffice')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ChangeTaxOffice}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblChangeTaxId')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ChangeTaxId}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblChangeIdNumber')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ChangeIdNumber}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblChangeReasonDetail')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ChangeReasonDesc}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblChangeServiceNote')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ChangeServiceNote}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblChangeShortNote')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ChangeShortNote}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblChangeReceived')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ChangeReceived === 1
                            ? 'True'
                            : 'False'}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblChangeBankName')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ChangeBankName}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblChangeBankCode')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ChangeBankCode}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblChangeIban')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ChangeIban}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblChangeInvoiceNr')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ChangeInvoiceNr}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblChangeInvoiceDate')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ChangeInvoiceDate === undefined
                            ? ''
                            : Moment(
                              consumerInformation.WarrantyDate
                            ).format('DD/MM/YYYY')}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblChangeInvoicePrice')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {moneyFormat(
                            consumerInformation.ChangeInvoicePrice,
                            SessionUser.TenantCode,
                            SessionUser.CurrencyUnit
                          )}
                          {' ' + SessionUser.CurrencyUnit}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblChangeProduct')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ChangeProduct}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <Card
                // style={{ maxHeight: 430, minHeight: 430 }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <CardHeader
                        style={{ textAlign: 'left' }}
                        title={t('lblWorkOrderInfo')}
                        action={<Box p={2.5} />}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <CardHeader
                        style={{ textAlign: 'right' }}
                        title={consumerInformation.ReceiptNo}
                        action={<Box p={2.5} />}
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblBrand')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.Brand}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblApplicationType')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.IssueReason}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblChannelType')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ChannelType}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblSourceOfDefect')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.SourceOfDefectDsc}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblModelCode')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ModelCode}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblModel')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.Model}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblProductionYear')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ProductionYear}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblProductionMonth')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ProductionMonth}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblSerialNr')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ProductSerialPrint ? consumerInformation.ProductSerialPrint :
                            consumerInformation.ExcelSerialNumber ? consumerInformation.ExcelSerialNumber :
                              consumerInformation.SerialNumber}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblBarcode')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.Barcode}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblWarrantyType')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.WarrantyTypeText}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblInvoiceDate')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.WarrantyDate === undefined
                            ? ''
                            : Moment(consumerInformation.WarrantyDate).format(
                              'DD/MM/YYYY'
                            )}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblWorkCaseIssue')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.WorkCaseIssue}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblWorkCaseStatus')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.WorkCaseStatus}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblStatus')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.Status}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblRejectDescription')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.RejectDescription
                            ? consumerInformation.RejectDescription.length > 50
                              ? consumerInformation.RejectDescription.substring(
                                0,
                                50
                              ) + '...'
                              : consumerInformation.RejectDescription
                            : ''}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblRejectReason')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.RejectReason}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblRetailer')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.Dealer}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblDistributor')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.Distributor}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblServiceShop')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ServiceShop}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblTechnician')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.Technician}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblFinalNote')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.StatusNote}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblCallCenterNote')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.CallCenterNote}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('ProjectCode')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.ProjectCode}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblPaymentType')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.PaymentType}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblPaymentDetail')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.PaymentDetail}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} lg={4}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblBillToConsumer')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.BillToConsumer}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <Card
                // style={{ maxHeight: 400, minHeight: 400 }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <CardHeader
                        style={{ textAlign: 'left' }}
                        title={t('lblDefectSummary')}
                        action={<Box p={2.5} />}
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">
                              {t('lblDefectCode')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblDefectDesc')}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {workOrderDetailList?.length > 0
                            ? workOrderDetailList.map(row => (
                              <TableRow key={row.LabourId}>
                                <TableCell align="center">
                                  {row.DefectDetailCode}
                                </TableCell>
                                <TableCell align="center">
                                  {row.DefectDetailDesc}
                                </TableCell>
                              </TableRow>
                            ))
                            : null}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <CardHeader
                        style={{ textAlign: 'left' }}
                        title={t('lblLabourMaterialInfo')}
                        action={<Box p={2.5} />}
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">
                              {t('lblDefect')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblLabourCode')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblLabourDesc')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblPriceWithoutVat')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblVat')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblLabourPrice')}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {workOrderLabourList?.length > 0
                            ? workOrderLabourList.map(row => (
                              <TableRow key={row.LabourId}>
                                <TableCell align="center">
                                  {row.DefectDesc}
                                </TableCell>
                                <TableCell align="center">
                                  {row.LabourCode}
                                </TableCell>
                                <TableCell align="center">
                                  {row.LabourDesc}
                                </TableCell>
                                <TableCell align="center">
                                  {moneyFormat(
                                    row.LabourPrice,
                                    SessionUser.TenantCode,
                                    SessionUser.CurrencyUnit
                                  )}
                                  {' ' + SessionUser.CurrencyUnit}
                                </TableCell>
                                <TableCell align="center">
                                  {moneyFormat(
                                    (row.LabourPriceWithWat - row.LabourPrice),
                                    SessionUser.TenantCode,
                                    SessionUser.CurrencyUnit
                                  )}
                                  {' ' + SessionUser.CurrencyUnit}
                                </TableCell>
                                <TableCell align="center">
                                  {moneyFormat(
                                    row.LabourPriceWithWat,
                                    SessionUser.TenantCode,
                                    SessionUser.CurrencyUnit
                                  )}
                                  {' ' + SessionUser.CurrencyUnit}
                                </TableCell>
                              </TableRow>
                            ))
                            : null}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <CardHeader
                        style={{ textAlign: 'left' }}
                        title={t('lblMaterialInfo')}
                        action={<Box p={2.5} />}
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">
                              {t('lblDefect')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblMaterialCode')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblMaterialDesc')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblCount')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblPriceWithoutVat')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblVat')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblMaterialPrice')}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {workOrderMaterialList?.length > 0
                            ? workOrderMaterialList.map(row => (
                              <TableRow key={row.MaterialId}>
                                <TableCell align="center">
                                  {row.DefectDesc}
                                </TableCell>
                                <TableCell align="center">
                                  {row.MaterialCode}
                                </TableCell>
                                <TableCell align="center">
                                  {row.MaterialDesc}
                                </TableCell>
                                <TableCell align="center">
                                  {row.Count}
                                </TableCell>
                                <TableCell align="center">
                                  {moneyFormat(
                                    row.MaterialPrice,
                                    SessionUser.TenantCode,
                                    SessionUser.CurrencyUnit
                                  )}
                                  {' ' + SessionUser.CurrencyUnit}
                                </TableCell>
                                <TableCell align="center">
                                  {moneyFormat(
                                    (row.MaterialPriceWithWat - row.MaterialPrice),
                                    SessionUser.TenantCode,
                                    SessionUser.CurrencyUnit
                                  )}
                                  {' ' + SessionUser.CurrencyUnit}
                                </TableCell>
                                <TableCell align="center">
                                  {moneyFormat(
                                    row.MaterialPriceWithWat,
                                    SessionUser.TenantCode,
                                    SessionUser.CurrencyUnit
                                  )}
                                  {' ' + SessionUser.CurrencyUnit}
                                </TableCell>
                              </TableRow>
                            ))
                            : null}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <CardHeader
                        style={{ textAlign: 'left' }}
                        title={t('lblTransportExtra')}
                        action={<Box p={2.5} />}
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">{t('lblCode')}</TableCell>
                            <TableCell align="center">
                              {t('lblDescription')}
                            </TableCell>
                            <TableCell align="center">{t('Km')}</TableCell>
                            <TableCell align="center">
                              {t('lblPriceWithoutVat')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblVat')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblPrice')}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {workOrderTransportList?.length > 0
                            ? workOrderTransportList.map(row => (
                              <TableRow key={row.MaterialId}>
                                <TableCell align="center">
                                  {row.MaterialCode}
                                </TableCell>
                                <TableCell align="center">
                                  {row.MaterialDesc}
                                </TableCell>
                                <TableCell align="center">
                                  {row.Count}
                                </TableCell>
                                <TableCell align="center">
                                  {moneyFormat(
                                    row.MaterialPrice,
                                    SessionUser.TenantCode,
                                    SessionUser.CurrencyUnit
                                  )}
                                  {' ' + SessionUser.CurrencyUnit}
                                </TableCell>
                                <TableCell align="center">
                                  {moneyFormat(
                                    (row.MaterialPriceWithWat - row.MaterialPrice),
                                    SessionUser.TenantCode,
                                    SessionUser.CurrencyUnit
                                  )}
                                  {' ' + SessionUser.CurrencyUnit}
                                </TableCell>
                                <TableCell align="center">
                                  {moneyFormat(
                                    row.MaterialPriceWithWat,
                                    SessionUser.TenantCode,
                                    SessionUser.CurrencyUnit
                                  )}
                                  {' ' + SessionUser.CurrencyUnit}
                                </TableCell>
                              </TableRow>
                            ))
                            : null}
                          {workOrderExtraList?.length > 0
                            ? workOrderExtraList.map(row => (
                              <TableRow key={row.MaterialId}>
                                <TableCell align="center">
                                  {row.MaterialCode}
                                </TableCell>
                                <TableCell align="center">
                                  {row.MaterialDesc}
                                </TableCell>
                                <TableCell align="center">-</TableCell>
                                <TableCell align="center">
                                  {moneyFormat(
                                    row.MaterialPriceWithWat,
                                    SessionUser.TenantCode,
                                    SessionUser.CurrencyUnit
                                  )}
                                  {' ' + SessionUser.CurrencyUnit}
                                </TableCell>
                              </TableRow>
                            ))
                            : null}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <CardHeader
                        style={{ textAlign: 'left' }}
                        title={t('lblTotalInterventionCost')}
                        action={<Box p={2.5} />}
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">
                              {t('lblDescription')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblPrice')}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell align="center">
                              {t('lblTotalLabourPrice')}
                            </TableCell>
                            <TableCell align="center">
                              {moneyFormat(
                                labourSum,
                                SessionUser.TenantCode,
                                SessionUser.CurrencyUnit
                              )}
                              {' ' + SessionUser.CurrencyUnit}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center">
                              {t('lblTotalMaterialPrice')}
                            </TableCell>
                            <TableCell align="center">
                              {moneyFormat(
                                materialSum,
                                SessionUser.TenantCode,
                                SessionUser.CurrencyUnit
                              )}
                              {' ' + SessionUser.CurrencyUnit}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center">
                              {t('lblTotalTransportPrice')}
                            </TableCell>
                            <TableCell align="center">
                              {moneyFormat(
                                transportSum,
                                SessionUser.TenantCode,
                                SessionUser.CurrencyUnit
                              )}
                              {' ' + SessionUser.CurrencyUnit}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center">
                              {t('lblTotalExtraPrice')}
                            </TableCell>
                            <TableCell align="center">
                              {moneyFormat(
                                extraPriceSum,
                                SessionUser.TenantCode,
                                SessionUser.CurrencyUnit
                              )}
                              {' ' + SessionUser.CurrencyUnit}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center">
                              {t('lblTotalPrice')}
                            </TableCell>
                            <TableCell align="center">
                              {moneyFormat(
                                transportSum + materialSum + labourSum + extraPriceSum,
                                SessionUser.TenantCode,
                                SessionUser.CurrencyUnit
                              )}
                              {' ' + SessionUser.CurrencyUnit}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>
              {Number(SessionUser?.TenantId) === 75 && (
                  <Grid item xs={12} sm={12} lg={12}>
                    <Card>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <CardHeader
                            style={{ textAlign: 'left' }}
                            title={t('lblPaymentDetails')}
                            action={<Box p={2.5} />}
                          />
                        </Grid>
                      </Grid>
                      <CardContent>
                        <TableContainer component={Paper}>
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell align="center">{t('lblMaterialType')}</TableCell>
                                <TableCell align="center">{t('lblMaterial')}</TableCell>
                                <TableCell align="center">{t('lblPriceVat')}</TableCell>
                                <TableCell align="center">{t('lblDiscount')}</TableCell>
                                <TableCell align="center">{t('lblTotalCollected')}</TableCell>
                                <TableCell align="center">{t('lblDawlanceShare')}</TableCell>
                                <TableCell align="center">{t('lblASCShare')}</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {PaymentDetails?.length > 0
                                ? PaymentDetails.map((row, idx) => (
                                    <TableRow key={idx}>
                                      <TableCell align="center">{row.MaterialType}</TableCell>
                                      <TableCell align="center">{row.Material}</TableCell>
                                      <TableCell align="center">
                                        {moneyFormat(
                                          row.PriceVat,
                                          SessionUser.TenantCode,
                                          SessionUser.CurrencyUnit
                                        )}
                                        {' ' + SessionUser.CurrencyUnit}
                                      </TableCell>
                                      <TableCell align="center">
                                        {moneyFormat(
                                          row.Discount,
                                          SessionUser.TenantCode,
                                          SessionUser.CurrencyUnit
                                        )}
                                        {' ' + SessionUser.CurrencyUnit}
                                      </TableCell>
                                      <TableCell align="center">
                                        {moneyFormat(
                                          row.TotalCollected,
                                          SessionUser.TenantCode,
                                          SessionUser.CurrencyUnit
                                        )}
                                        {' ' + SessionUser.CurrencyUnit}
                                      </TableCell>
                                      <TableCell align="center">
                                        {moneyFormat(
                                          row.DawlanceShare,
                                          SessionUser.TenantCode,
                                          SessionUser.CurrencyUnit
                                        )}
                                        {' ' + SessionUser.CurrencyUnit}
                                      </TableCell>
                                      <TableCell align="center">
                                        {moneyFormat(
                                          row.ACSShare,
                                          SessionUser.TenantCode,
                                          SessionUser.CurrencyUnit
                                        )}
                                        {' ' + SessionUser.CurrencyUnit}
                                      </TableCell>
                                    </TableRow>
                                  ))
                                : null}
                              {PaymentDetails?.length > 0 && (
                                <TableRow style={{ fontWeight: 'bold' }}>
                                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                    {t('lblTotal')}
                                  </TableCell>
                                  <TableCell align="center" style={{ fontWeight: 'bold' }}>-</TableCell>
                                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                    {moneyFormat(
                                      PaymentDetails.reduce((sum, row) => sum + (row.PriceVat || 0), 0),
                                      SessionUser.TenantCode,
                                      SessionUser.CurrencyUnit
                                    )}
                                    {' ' + SessionUser.CurrencyUnit}
                                  </TableCell>
                                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                    {moneyFormat(
                                      PaymentDetails.reduce((sum, row) => sum + (row.Discount || 0), 0),
                                      SessionUser.TenantCode,
                                      SessionUser.CurrencyUnit
                                    )}
                                    {' ' + SessionUser.CurrencyUnit}
                                  </TableCell>
                                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                    {moneyFormat(
                                      PaymentDetails.reduce((sum, row) => sum + (row.TotalCollected || 0), 0),
                                      SessionUser.TenantCode,
                                      SessionUser.CurrencyUnit
                                    )}
                                    {' ' + SessionUser.CurrencyUnit}
                                  </TableCell>
                                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                    {moneyFormat(
                                      PaymentDetails.reduce((sum, row) => sum + (row.DawlanceShare || 0), 0),
                                      SessionUser.TenantCode,
                                      SessionUser.CurrencyUnit
                                    )}
                                    {' ' + SessionUser.CurrencyUnit}
                                  </TableCell>
                                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                                    {moneyFormat(
                                      PaymentDetails.reduce((sum, row) => sum + (row.ACSShare || 0), 0),
                                      SessionUser.TenantCode,
                                      SessionUser.CurrencyUnit
                                    )}
                                    {' ' + SessionUser.CurrencyUnit}
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </CardContent>
                    </Card>
                  </Grid>
                )}
              <Grid item xs={12} sm={12} lg={12}>
                <Card
                // style={{ maxHeight: 400, minHeight: 400 }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <CardHeader
                        style={{ textAlign: 'left' }}
                        title={t('lblASIFormInfo')}
                        action={<Box p={2.5} />}
                      />
                    </Grid>
                  </Grid>
                  <CardContent>
                    <TableContainer component={Paper}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">
                              {t('lblEngineerFindings')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblDetailsofDamage')}
                            </TableCell>
                            <TableCell align="center">
                              {t('lblAnyOtherRelevantInformation')}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ASIFormInfoList?.length > 0
                            ? ASIFormInfoList.map(row => (
                              <TableRow key={row.EngineerFindings}>
                                <TableCell align="center">{row.EngineerFindings}</TableCell>
                                <TableCell align="center">{row.DamageDetails}</TableCell>
                                <TableCell align="center">{row.OtherInfo}</TableCell>
                              </TableRow>
                            ))
                            : null}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <Card
                // style={{ maxHeight: 140, minHeight: 140 }}
                >
                  <CardContent>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={2} lg={2}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblCreateUser')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.CreateUser}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} lg={2}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblCallDate')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {Moment(consumerInformation.WorkCaseCallDate).format('DD/MM/YYYY HH:mm')}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} lg={2}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblPreferredDate')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.PreferredDate === undefined
                            ? ''
                            : Moment(consumerInformation.PreferredDate).format(
                              'DD/MM/YYYY HH:mm'
                            )}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} lg={2}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblFirstAppointmentDate')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.FirstAppointmentDate === undefined
                            ? ''
                            : Moment(consumerInformation.FirstAppointmentDate).format(
                              'DD/MM/YYYY HH:mm'
                            )}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} lg={2}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblOperationStartDate')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.OperationStartDate === undefined
                            ? ''
                            : Moment(
                              consumerInformation.OperationStartDate
                            ).format('DD/MM/YYYY HH:mm')}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} lg={2}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblBarcodeReadDate')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.BarcodeReadDate ===
                            undefined
                            ? ''
                            : Moment(
                              consumerInformation.BarcodeReadDate
                            ).format('DD/MM/YYYY HH:mm')}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} lg={2}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblRepairDate')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          {consumerInformation.VerificationDate === undefined
                            ? ''
                            : Moment(
                              consumerInformation.VerificationDate
                            ).format('DD/MM/YYYY HH:mm')}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} lg={2}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblFile')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          <IconButton onClick={() => setFileDialog(true)}>
                            <PhotoLibraryIcon />
                          </IconButton>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} lg={2}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblWorkOrderHistory')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          <IconButton
                            onClick={() => setWorkOrderHistoryDialog(true)}
                          >
                            <HistoryIcon />
                          </IconButton>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} lg={2}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblProductHistory')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          <IconButton
                            onClick={() => setProductHistoryDialog(true)}
                          >
                            <SettingsBackupRestoreIcon />
                          </IconButton>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} lg={2}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblLibrary')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          <IconButton onClick={() => setLibraryDialog(true)}>
                            <LocalLibraryIcon />
                          </IconButton>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} lg={2}>
                        <Typography
                          className={classes.title}
                          color="textSecondary"
                        >
                          {t('lblNotes')}
                        </Typography>
                        <Typography variant="h6" component="h2" gutterBottom>
                          <IconButton
                            onClick={() => getWorkOrderCommentDetail()}
                          >
                            <CommentOutlinedIcon />
                          </IconButton>
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Dialog
          open={FileDialog}
          // fullWidth={true}
          maxWidth="lg"
          onClose={event => setFileDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{t('lblFile')}</DialogTitle>
          <DialogContent>
            <Fotograf ReceiptNo={ReceiptNo} readonly={false} />
          </DialogContent>
          <DialogActions>
            <IconButton
              color="primary"
              onClick={event => setFileDialog(false)}
              aria-label="upload picture"
              component="span"
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
        </Dialog>
        <Dialog
          open={WorkOrderHistoryDialog}
          fullWidth
          maxWidth="lg"
          onClose={event => setWorkOrderHistoryDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{t('Fis_Tarihce')}</DialogTitle>
          <DialogContent>
            <History ReceiptNo={ReceiptNo} readonly={false} />
          </DialogContent>
          <DialogActions>
            <IconButton
              color="primary"
              onClick={event => setWorkOrderHistoryDialog(false)}
              aria-label="upload picture"
              component="span"
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
        </Dialog>
        <Dialog
          open={ProductHistoryDialog}
          fullWidth
          maxWidth="lg"
          onClose={event => setProductHistoryDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{t('urun_tarihce')}</DialogTitle>
          <DialogContent>
            <UrunTarihce
              UrunData={data}
              setProductHistoryDialog={setProductHistoryDialog}
            />
          </DialogContent>
          <DialogActions>
            <IconButton
              color="primary"
              onClick={event => setProductHistoryDialog(false)}
              aria-label="upload picture"
              component="span"
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
        </Dialog>
        <Dialog
          open={LibraryDialog}
          fullWidth
          maxWidth="lg"
          onClose={event => setLibraryDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{t('lblLibrary')}</DialogTitle>
          <DialogContent>
            <Bulten ReceiptNo={ReceiptNo} readonly={false} />
          </DialogContent>
          <DialogActions>
            <IconButton
              color="primary"
              onClick={event => setLibraryDialog(false)}
              aria-label="upload picture"
              component="span"
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
        </Dialog>
        <Dialog
          open={CommentDialog}
          fullWidth
          maxWidth="md"
          onClose={event => setCommentDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{t('lblComment')}</DialogTitle>
          <Divider />
          <DialogContent>
            {WorkOrderCommentsData.map((item, index) => (
              <Grid item xs={12} sm={6} lg={6} key={index}>
                <DisplayField
                  label={item.Type + '-' + item.Employee}
                  value={item.Dsc}
                />
              </Grid>
            ))}
          </DialogContent>
          <DialogActions>
            <IconButton
              color="primary"
              onClick={event => setCommentDialog(false)}
              aria-label="upload picture"
              component="span"
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
        </Dialog>
        <Dialog
          open={productNotesPopup}
          onClose={() => setProductNotesPopup(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="lg"
          fullWidth
        >
          <DialogContent>
            <Notes />
          </DialogContent>
        </Dialog>
      </Container>
    </div>
  );
};

export default WorkOrderDetail;
